import routes from './routes'
import { createRouter, createWebHistory } from 'vue-router'
// import { createRouter, createWebHistory, START_LOCATION } from 'vue-router'
// import ROLES from '@/constants/ROLES'
// import store from '@/store'

export const history = createWebHistory(process.env.BASE_URL)

const router = createRouter({
  history,
  routes,
})

// const checkRouteRoles = to => {
//   if (!to.meta.roles || !to.meta.roles.length) return true
//   for (const role of to.meta.roles) {
//     switch (role) {
//       case ROLES.CONNECTED: {
//         if (!store.getters.isAuthenticated) {
//           return '/login?redirect=' + encodeURIComponent(to.path)
//         }
//         break
//       }
//       case ROLES.EVERYONE:
//       default: {
//         break
//       }
//     }
//   }
//   if (to.name === 'Login' && store.getters.isAuthenticated) {
//     if (to.query.from) {
//       const newRoute = decodeURIComponent(to.query.redirect)
//       if (newRoute[0] === '/') {
//         // Making sure this links to an internal link
//         // This avoids attacks to users linking to malicious sites!
//         return newRoute
//       }
//     }
//     return '/dashboard'
//   }
//   return true
// }

// export const checkRouteRolesRedirect = to => {
//   const result = checkRouteRoles(to)
//   if (typeof result === 'string') {
//     router.replace(result)
//   }
// }

// router.beforeResolve((to, from) => {
//   if (from === START_LOCATION) {
//     // Handled by main.js
//     return
//   }
//   return checkRouteRoles(to, from)
// })

export default router
